import { useHistory, useLocation, useRouteMatch } from 'react-router';
import ConfirmModal from '../../../components/modals/ConfirmModal';
import useNotification from '../../../hooks/useNotification';
import { IGetMessage } from '../../../models/messages.model';
import useAxios from '../../../hooks/useAxios';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { deleteSentMessages, getSentMessage } from '../../../api/messages.api';
import Loader from '../../../components/Loader';
import ErrorResponse from '../../../components/ErrorResponse';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import { Descriptions } from 'antd';
import moment from 'moment';
import Button from '../../../components/Button';
import useAuth from '../../../hooks/useAuth';
import MessageReadModal from '../../../components/message/MessageReadModal';

interface IMatch {
  messageCode: string;
}

const MessageSendRead = () => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const match = useRouteMatch<IMatch>();
  const messageCode = Number(match.params.messageCode);
  const history = useHistory();
  const location = useLocation();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetMessage>();
  const {
    data: deleteRes,
    isLoading: deleteIsLoading,
    error: deleteError,
    execute: deleteExecute,
  } = useAxios();

  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
  const [messageReadVisible, setMessageReadVisible] = useState(false);

  useEffect(() => {
    execute(getSentMessage(messageCode));
  }, []);

  useEffect(() => {
    if (deleteRes && !deleteIsLoading) {
      successNotification(t('common.message.delete'));
      history.push(`/message/send${location.search}`);
    }
  }, [deleteRes, deleteIsLoading]);

  const onDelete = () => {
    deleteExecute(deleteSentMessages([messageCode]));
  };

  return (
    <div className="content scrollbar">
      {isLoading || deleteIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={deleteError} />
      <SimpleHeader
        parentMenu={t('common.menu.message')}
        currentMenu={t('message.send.title1')}
      />

      <div className='comm-table__area rowType'>
        <Descriptions
          bordered
          column={1}
          size="middle"
          labelStyle={{ width: '200px' }}
        >
          <Descriptions.Item label={t('common.column.title')}>
            {res?.data.title}
          </Descriptions.Item>
          <Descriptions.Item label={t('message.archive.column1')}>
            {res?.data.sendMemKorName} ({res?.data.sendWebId})
          </Descriptions.Item>
          <Descriptions.Item label={t('message.archive.column3')}>
            {res?.data.recipientInfo.map((item) => (
              <span className="mr-3" key={item.recipientMemCode}>
                {item.recipientMemKorName} ({item.recipientWebId})
              </span>
            ))}
          </Descriptions.Item>
          <Descriptions.Item label={t('message.send.1')}>
            {moment(res?.data.sendDate).format('YYYY.MM.DD HH:mm')}
          </Descriptions.Item>
          <Descriptions.Item label={t('common.column.contents')}>
            <div
              dangerouslySetInnerHTML={{ __html: res?.data.content || '' }}
            />
          </Descriptions.Item>
          <Descriptions.Item label={t('common.column.file')}>
            {res?.data.files ? (
              res?.data.files.map((item: any) => (
                <div>
                  <a
                    className="download-link"
                    href={`${item.fileLocation}`}
                    download={item.originalName}
                  >
                    {item.originalName}
                  </a>
                </div>
              ))
            ) : (
              <div />
            )}
          </Descriptions.Item>
          <Descriptions.Item label={t('message.archive.column6')}>
            <div className="comm-btn__area">
              <Button
                className="btn-basic gray-line small"
                onClick={() => setMessageReadVisible(true)}
                text={t('message.archive.button2')}
              />
            </div>
          </Descriptions.Item>
        </Descriptions>
      </div>
      <div className="comm-bx__between">
        <div className="comm-btn__area">
          <Button
            className="btn-basic gray-line"
            onClick={() => history.push(`/message/send${location.search}`)}
            text={t('common.button.list')}
          />
        </div>
        <div className="comm-btn__area right">
          <Button
            className="btn-basic pink-line"
            onClick={() => {
              sessionStorage.setItem('title', `Fw: ${res?.data.title}`);
              sessionStorage.setItem('content', res?.data.content || '');
              sessionStorage.setItem(
                'messageCode',
                String(res?.data.messageCode || ''),
              );
              sessionStorage.setItem(
                'attachFileCode',
                String(res?.data.attachFileCode || ''),
              );
              sessionStorage.setItem(
                'files',
                JSON.stringify(res?.data.files),
              );
              history.push('/message/write');
            }}
            text={t('common.button.relay')}
            writeAuthYn={writeAuthYn}
          />
          <Button
            className="btn-basic gray"
            onClick={() => setConfirmDeleteVisible(true)}
            text={t('common.button.delete')}
            writeAuthYn={writeAuthYn}
          />
        </div>
      </div>

      {confirmDeleteVisible && (
        <ConfirmModal
          visible={confirmDeleteVisible}
          setVisible={setConfirmDeleteVisible}
          onConfirm={onDelete}
          titleText={t('message.archive.title2')}
          messageText={t('message.archive.text1')}
          confirmText={t('common.button.delete')}
          cancelText={t('common.button.cancel')}
        />
      )}

      {messageReadVisible && (
        <MessageReadModal
          visible={messageReadVisible}
          setVisible={setMessageReadVisible}
          messageCode={messageCode}
        />
      )}
    </div>
  );
};

export default MessageSendRead;
